import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useWindowSize from '~/components/hooks/useWindowSize';

export const SlideLoader = props => {
	const { width } = useWindowSize();
	return (
		<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
			<Skeleton style={{ aspectRatio: width > 650 ? '160/82' : '75/93', display: 'block' }} />
		</SkeletonTheme>
	);
};

export const PuzzleBannerLoader = props => {
	return (
		<div className="puzzle-banner-loader">
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<div className="container">
					<Skeleton style={{ aspectRatio: '572/227', display: 'block' }} />
					<Skeleton style={{ aspectRatio: '572/227', display: 'block' }} />
					<Skeleton style={{ aspectRatio: '572/227', display: 'block' }} />
					<Skeleton style={{ aspectRatio: '572/227', display: 'block' }} />
				</div>
			</SkeletonTheme>
		</div>
	);
};

export const SportSliderLoader = props => {
	return (
		<div className="sports-slider-loader">
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<Skeleton style={{ display: 'block', height: '34px', maxWidth: '280px', margin: '36px auto' }} />
				<div className="container">
					<Skeleton style={{ display: 'block' }} />
					<Skeleton style={{ display: 'block' }} />
					<Skeleton style={{ display: 'block' }} />
					<Skeleton style={{ display: 'block' }} />
					<Skeleton style={{ display: 'block' }} />
					<Skeleton style={{ display: 'block' }} />
				</div>
			</SkeletonTheme>
		</div>
	);
};

export const FiltersBannerLoader = props => {
	return (
		<div className="filters-banner-loader">
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<div className="container">
					<Skeleton style={{ display: 'block' }} />
					<Skeleton style={{ display: 'block' }} />
					<Skeleton style={{ display: 'block' }} />
				</div>
			</SkeletonTheme>
		</div>
	);
};

export const BrandsLoader = () => {
	return (
		<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
			<div className="brands-container">
				{Array.from({ length: 8 }, (_, i) => (
					<div key={i} className="brand-item">
						<Skeleton style={{ aspectRatio: '167/128', display: 'block' }} />
					</div>
				))}
			</div>
		</SkeletonTheme>
	);
};

export const SalesProductsLoader = props => {
	return (
		<div className="salesproducts-loader">
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<div className="container">
					<Skeleton style={{ display: 'block', height: '415px' }} />
				</div>
			</SkeletonTheme>
		</div>
	);
};

export const ProductCardLoader = props => {
	return (
		<>
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3" inline>
				<Skeleton width={'100%'} height={420} count={1} />
			</SkeletonTheme>
		</>
	);
};

export const ProductSearchLoader = props => {
	return (
		<SkeletonTheme baseColor="#e3e6e8" highlightColor="#c5c8c9">
			<div style={{ marginLeft: 40, marginTop: 40 }}>
				<Skeleton
					count={3}
					height={80}
					style={{
						display: 'block',
						lineHeight: 2
					}}
				/>
			</div>
		</SkeletonTheme>
	);
};

export const CategorySearchLoader = props => {
	return (
		<SkeletonTheme baseColor="#e3e6e8" highlightColor="#c5c8c9">
			<Skeleton
				count={4}
				style={{
					display: 'block',
					lineHeight: 2
				}}
			/>
		</SkeletonTheme>
	);
};

export const CouponsLoader = props => {
	return (
		<>
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<Skeleton style={{ lineHeight: 6.5 }} count={5} height={40} />
			</SkeletonTheme>
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#444">
				<Skeleton style={{ marginTop: 30 }} height={40} width="50%" />
			</SkeletonTheme>
		</>
	);
};

export const CheckoutStep3Loader = props => {
	return (
		<>
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<Skeleton style={{ marginTop: 20 }} count={4} height={30} />
			</SkeletonTheme>
		</>
	);
};

export const ShippingOptionsLoader = () => (
	<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
		<Skeleton height={20} width="45%" style={{ display: 'block', marginTop: 25, marginBottom: 30 }} />
		<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
			<Skeleton height={45} style={{ display: 'block' }} />
			<Skeleton height={45} style={{ display: 'block' }} />
			<Skeleton height={45} style={{ display: 'block' }} />
		</div>
	</SkeletonTheme>
);

export const PaymentOptionsLoader = () => (
	<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
		<div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
			<Skeleton height={90} style={{ display: 'block' }} />
			<Skeleton height={90} style={{ display: 'block' }} />
			<Skeleton height={90} style={{ display: 'block' }} />
		</div>
	</SkeletonTheme>
);

export const GiftCheckboxLoader = () => (
	<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
		<Skeleton height={45} style={{ display: 'block', marginBottom: 35 }} />
	</SkeletonTheme>
);

export const FiltersModalLoader = props => {
	return (
		<>
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<Skeleton style={{ marginTop: 20 }} height={20} width="25%" />
				<Skeleton style={{ marginTop: 20 }} count={2} height={30} />
				<Skeleton style={{ marginTop: 20 }} height={20} width="25%" />
				<Skeleton style={{ marginTop: 20 }} count={2} height={30} />
				<Skeleton style={{ marginTop: 20 }} height={20} width="25%" />
				<Skeleton style={{ marginTop: 20 }} count={2} height={30} />
			</SkeletonTheme>
		</>
	);
};

export const FiltersProductListLoader = props => {
	return (
		<>
			<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
				<Skeleton style={{ marginTop: 0, marginRight: 60 }} height={40} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 60 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />

				<Skeleton style={{ marginTop: 50 }} height={40} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />

				<Skeleton style={{ marginTop: 50 }} height={40} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
				<Skeleton style={{ marginTop: 10, marginRight: 100 }} height={30} count={1} width="85%" />
			</SkeletonTheme>
		</>
	);
};

export const CategoryTitleLoader = () => (
	<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
		<Skeleton style={{ display: 'block' }} height={24} width="55%" />
	</SkeletonTheme>
);

export const CategoryCountLoader = () => (
	<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
		<Skeleton style={{ display: 'block' }} height={15} width={160} />
	</SkeletonTheme>
);

export const CategoryDescLoader = () => {
	return (
		<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
			<Skeleton style={{ marginBottom: 6, display: 'block' }} height={16} count={3} />
		</SkeletonTheme>
	);
};

export const CatalogFilterLoader = props => {
	return (
		<>
			<div className="content-wrapper catalogfilter-loading-container">
				<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
					<Skeleton style={{ marginBottom: 40 }} height={30} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={60} count={1} />
				</SkeletonTheme>
			</div>
		</>
	);
};

export const LandingPageBannersLoader = ({ isSimpleLandingPage = false }) => {
	return (
		<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
			<div className={isSimpleLandingPage ? 'brand-categories-container simple-landingPage' : 'brand-categories-container'}>
				{Array.from({ length: 3 }, (_, i) => (
					<div key={i} className="category">
						<Skeleton style={{ display: 'block', height: 24, width: '60%', marginBottom: 18 }} />
						<Skeleton style={{ display: 'block', aspectRatio: '375 / 280', width: '100%' }} />
					</div>
				))}
			</div>
		</SkeletonTheme>
	);
};

export const PersonalizedProductsLoader = () => {
	const { width } = useWindowSize();
	const cardCount = width >= 1265 ? 4 : width >= 768 ? 3 : width > 350 ? 2 : 1;

	return (
		<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
			<Skeleton style={{ display: 'block', height: 32, width: 220, margin: '0 auto 24px' }} />
			<div style={{ display: 'grid', gridTemplateColumns: `repeat(${cardCount}, 1fr)`, gap: 10 }}>
				{Array.from({ length: cardCount }, (_, i) => (
					<Skeleton key={i} style={{ display: 'block', height: 420, width: '100%' }} />
				))}
			</div>
		</SkeletonTheme>
	);
};

export const ProductListLoader = ({ count = 24 }) => {
	return (
		<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3" inline>
			{Array.from({ length: count }, (_, i) => (
				<Skeleton key={i} style={{ marginTop: 20 }} height={400} count={1} />
			))}
		</SkeletonTheme>
	);
};

export const ProductPageLoader = props => {
	return (
		<>
			<div className="content-wrapper product-loading-container">
				<div className="img-info">
					<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
						<div>
							<Skeleton height={500} count={1} inline />
						</div>
						<div>
							<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
								<Skeleton style={{ marginBottom: '15px' }} height={45} count={1} />
								<Skeleton style={{ marginBottom: '20px' }} height={10} count={1} />
								<Skeleton style={{ marginBottom: '20px' }} height={20} count={1} />
								<Skeleton style={{ marginBottom: '20px' }} height={20} count={1} />
								<div className="colors">
									<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
										<Skeleton style={{ marginBottom: '15px' }} height={45} count={1} />
										<Skeleton style={{ marginBottom: '20px' }} height={45} count={1} />
									</SkeletonTheme>
								</div>
								<Skeleton style={{ marginBottom: '20px' }} height={20} count={1} />
								<div className="sizes">
									<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
										<Skeleton style={{ marginBottom: '15px' }} height={45} count={1} />
										<Skeleton style={{ marginBottom: '20px' }} height={45} count={1} />
										<Skeleton style={{ marginBottom: '15px' }} height={45} count={1} />
										<Skeleton style={{ marginBottom: '20px' }} height={45} count={1} />
										<Skeleton style={{ marginBottom: '15px' }} height={45} count={1} />
										<Skeleton style={{ marginBottom: '20px' }} height={45} count={1} />
									</SkeletonTheme>
								</div>
								<Skeleton style={{ marginBottom: '15px' }} height={70} count={1} />
							</SkeletonTheme>
						</div>
					</SkeletonTheme>
				</div>
				<div className="description">
					<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
						<Skeleton height={500} count={1} inline />
					</SkeletonTheme>
				</div>
			</div>
		</>
	);
};

export const SearchResultsLoader = props => {
	return (
		<>
			<SkeletonTheme baseColor="#eee" highlightColor="#ccc" inline>
				<div className="search-results-loader">
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
					<Skeleton style={{ marginTop: 20 }} height={370} count={1} />
				</div>
			</SkeletonTheme>
		</>
	);
};

export const FooterTopBoxesLoader = () => (
	<div id="footer-top-boxes">
		<div className="content-wrapper">
			<div className="footer-top-boxes-container">
				<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
					{Array.from({ length: 3 }, (_, i) => (
						<div key={i} className="border-linear">
							<div className="footer-box">
								<Skeleton width={60} height={60} />
								<Skeleton style={{ display: 'block', marginTop: 20, height: 20, width: '80%' }} />
								<Skeleton style={{ display: 'block', marginTop: 8, height: 16, width: '60%' }} />
							</div>
						</div>
					))}
				</SkeletonTheme>
			</div>
		</div>
	</div>
);

export const CmsNavigationLoader = () => (
	<SkeletonTheme baseColor="#f9f9f9" highlightColor="#e8e4e3">
		<ul className="sidebar" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
			{Array.from({ length: 5 }, (_, i) => (
				<li key={i} style={{ marginBottom: 15 }}>
					<Skeleton height={46} style={{ display: 'block', borderRadius: 0 }} />
				</li>
			))}
		</ul>
	</SkeletonTheme>
);

export const OrderListLoader = () => {
	const isMobile = window.innerWidth <= 641;
	return (
		<SkeletonTheme baseColor="#eee" highlightColor="#ccc">
			{[0, 1, 2].map(i => (
				<Skeleton key={i} height={isMobile ? 265 : 70} style={{ marginBottom: isMobile ? 15 : 17, display: 'block', borderRadius: 0 }} />
			))}
		</SkeletonTheme>
	);
};

export const AddressListLoader = () => (
	<SkeletonTheme baseColor="#eee" highlightColor="#ccc">
		{[0, 1, 2].map(i => (
			<Skeleton key={i} height={70} style={{ marginBottom: 17, display: 'block', borderRadius: 0 }} />
		))}
	</SkeletonTheme>
);

export const GiftcardOptionsLoader = props => {
	return (
		<div className="giftcard-loader">
			<SkeletonTheme baseColor="#eee" highlightColor="#ccc" inline>
				<div className="title-option">
					<Skeleton style={{ marginTop: 20 }} height={30} count={1} />
				</div>
				<div className="options">
					<Skeleton style={{ marginTop: 35 }} height={50} count={1} />
					<Skeleton style={{ marginTop: 35 }} height={50} count={1} />
					<Skeleton style={{ marginTop: 35 }} height={50} count={1} />
					<Skeleton style={{ marginTop: 35 }} height={50} count={1} />
					<Skeleton style={{ marginTop: 35 }} height={50} count={1} />
					<Skeleton style={{ marginTop: 35 }} height={50} count={1} />
				</div>
				<div className="title-quantity">
					<Skeleton style={{ marginTop: 45 }} height={30} count={1} />
				</div>
				<div className="quantity">
					<Skeleton style={{ marginTop: 16 }} height={38} count={1} />
				</div>
				<div className="next-step-skeleton">
					<Skeleton style={{ marginTop: 25 }} height={51} count={1} />
				</div>
			</SkeletonTheme>
		</div>
	);
};
